import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import EmptyCard from 'srcReact/Dashboard/components/common/EmptyCard'
import NewMemberGraph from '../NewMemberGraph'
import { useTranslation } from 'react-i18next'
import CardSubTitle from 'srcReact/Dashboard/components/common/CardSubTitle'
import UserList from 'srcReact/Dashboard/components/common/UserList'
import Spinner from 'srcReact/components/common2/Spinner'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmModal from 'srcReact/components/common2/ConfirmModal'
import { dashboardActions } from 'srcReact/Dashboard/actions'
import Counts from 'srcReact/Dashboard/components/common/Counts'
import Button from 'srcReact/components/common2/Button'
import { isMobileScreen } from 'srcReact/helpers/utils'

function MembersActivity({ type, objectId, memberActivityData, duration, loading }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [newMembers, setNewMembers] = useState(null)
  const [graphData, setGraphData] = useState(null)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [userToRemove, setUserToRemove] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const {
    login: { user: loggedInUser },
    dashboardDetail: {
      removeNewMember: { loading: removeUserLoading, success, error }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (memberActivityData && memberActivityData[duration]) {
      const durationData = memberActivityData[duration]
      if (durationData) {
        setNewMembers(durationData)
      }
      if (duration === '4W') {
        setGraphData(memberActivityData['7D'])
      } else if (duration === '88D') {
        setGraphData(memberActivityData['22D'])
      } else {
        setGraphData(memberActivityData['91D'])
      }
    }
  }, [memberActivityData, duration])

  useEffect(() => {
    if (!removeUserLoading) {
      if (success) {
        closeConfirmModal()
      }
      setErrorMessage(error || '')
    }
  }, [removeUserLoading])

  const openConfirmModal = (user) => {
    setIsConfirmModalOpen(true)
    setUserToRemove(user)
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false)
    setUserToRemove(null)
    setErrorMessage('')
  }

  const removeUser = () => {
    dispatch(dashboardActions.removeNewMember(type, objectId, userToRemove.id, 'activity', duration))
  }

  return (
    <div className={parentStyles.activityData}>
      <div className={parentStyles.left}>
        {loading ? (
          <Spinner />
        ) : newMembers?.new_member?.length > 0 ? (
          <UserList
            users={newMembers.new_member}
            loggedInUser={loggedInUser}
            renderAction={(userInfo) => (
              <Button style='transparent' text={t('global.remove')} handleClick={() => openConfirmModal(userInfo)} />
            )}
          />
        ) : (
          <EmptyCard
            className={styles.invites}
            contentTitle={t('dashboard.activity.newMembers.onlyMember')}
            contentText={t('dashboard.activity.newMembers.text')}
            contentImage='pending-invites'
            contentButton={t('global.inviteMembers')}
            contentButtonLink={`/0/group/${objectId}/invite-members`}
            linkTarget='_blank'
          />
        )}
      </div>
      {!isMobileScreen() && (
        <div className={parentStyles.right}>
          <Counts
            countTitle={t('dashboard.activity.newMembers.newMemberCount', {
              count: parseInt(newMembers?.new_member_count?.value) || 0
            })}
            totalCountTitle={t('dashboard.activity.newMembers.totalMembers', {
              count: newMembers?.total_member_count?.value || 0
            })}
            count={newMembers?.new_member_variation?.value}
            totalCount={newMembers?.total_member_variation?.value}
          />
          <NewMemberGraph graphData={graphData?.members_graph} />
        </div>
      )}

      <ConfirmModal
        title={t('global.removeUserConfirm', { username: `${userToRemove?.firstname} ${userToRemove?.lastname}` })}
        isOpen={isConfirmModalOpen}
        closeModal={closeConfirmModal}
        handlePrimaryButton={removeUser}
        handleSecondaryButton={closeConfirmModal}
        error={errorMessage}
      />
    </div>
  )
}

export default MembersActivity
